module.exports = __webpack_public_path__ + "static/media/Blue_Tape_Final.3925cd74.mov";